export default __webpack_public_path__ + "static/media/Tagainiso.c93d1f04.jpg";